var magicStyles = [".periodic-account-review-modal[data-v-c4cf2f5a]{display:flex;flex-wrap:wrap;justify-content:center}.text[data-v-c4cf2f5a]{font-weight:var(--magic-font-weight-semibold,600);margin:0 0 var(--magic-space,16px) 0;color:var(--magic-text-medium,#747474)}"];

export default magicStyles;
